import { Injectable } from '@angular/core';
import CryptoES from 'crypto-es';
import * as forge from 'node-forge';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EncryptDecryptService {
  private publicKEY = environment.public_key;

  constructor() {}

  claveAleatoria() {
    const caracteres =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let clave = '';
    //// 256 bits / 8 bits por byte = 32 bytes
    for (let i = 0; i < 32; i++) {
      const indice = Math.floor(Math.random() * caracteres.length);
      clave += caracteres.charAt(indice);
    }
    return clave;
  }

  encryptData(body: any, clave: string): any {
    var keys = CryptoES.enc.Utf8.parse(clave);
    var iv = CryptoES.enc.Utf8.parse(clave.substring(0, 16));
    var encrypted = CryptoES.AES.encrypt(JSON.stringify(body), keys, {
      iv: iv,
      mode: CryptoES.mode.CBC,
    });
    return encrypted.toString();
  }

  encryptKey(clave: string): any {
    const rsa = forge.pki.publicKeyFromPem(this.publicKEY);
    const encrypted = rsa.encrypt(clave);
    // const encrypted = rsa.encrypt(clave, 'RSA-OAEP');
    return forge.util.encode64(encrypted);
  }
}
